export * from './berichts-vorlage-post-request.interface';
export * from './berichts-vorlage-post-response.interface';
export * from './berichts-vorlage-post.shapes';
